import { format, isThisYear } from "date-fns";

export default function notiFormatDate(timestamp) {
  const date = new Date(timestamp);

  if (isThisYear(date)) {
    return format(date, "d MMM, h:mm a");
  } else {
    return format(date, "d MMM yyyy, h:mm a");
  }
}
